import * as React from "react";
import { PenPathPreview } from "../../../../TypesAndConstants/types";

export const paths: PenPathPreview[] = [
  {
    path: 0,
    url: "",
  },
  {
    path: 1,
    url: require("../../../../../Assets/PenPaths/filename (2).png"),
  },
  {
    path: 2,
    url: require("../../../../../Assets/PenPaths/filename (3).png"),
  },
  {
    path: 3,
    url: require("../../../../../Assets/PenPaths/filename (4).png"),
  },
  {
    path: 4,
    url: require("../../../../../Assets/PenPaths/filename (5).png"),
  },
  {
    path: 5,
    url: require("../../../../../Assets/PenPaths/filename (6).png"),
  },
  {
    path: 6,
    url: require("../../../../../Assets/PenPaths/filename (7).png"),
  },
  {
    path: 7,
    url: require("../../../../../Assets/PenPaths/filename (8).png"),
  },
  {
    path: 8,
    url: require("../../../../../Assets/PenPaths/filename (9).png"),
  },
  {
    path: 9,
    url: require("../../../../../Assets/PenPaths/filename (10).png"),
  },
  {
    path: 10,
    url: require("../../../../../Assets/PenPaths/filename (11).png"),
  },
  {
    path: 11,
    url: require("../../../../../Assets/PenPaths/filename (12).png"),
  },
  {
    path: 12,
    url: require("../../../../../Assets/PenPaths/filename (13).png"),
  },
  {
    path: 13,
    url: require("../../../../../Assets/PenPaths/filename (14).png"),
  },
  {
    path: 14,
    url: require("../../../../../Assets/PenPaths/filename (15).png"),
  },
  {
    path: 15,
    url: require("../../../../../Assets/PenPaths/filename (16).png"),
  },
  {
    path: 16,
    url: require("../../../../../Assets/PenPaths/filename (17).png"),
  },
  {
    path: 17,
    url: require("../../../../../Assets/PenPaths/filename (18).png"),
  },
  {
    path: 18,
    url: require("../../../../../Assets/PenPaths/filename (19).png"),
  },
  {
    path: 19,
    url: require("../../../../../Assets/PenPaths/filename (20).png"),
  },
  {
    path: 20,
    url: require("../../../../../Assets/PenPaths/filename (21).png"),
  },
  {
    path: 21,
    url: require("../../../../../Assets/PenPaths/filename (22).png"),
  },
  {
    path: 22,
    url: require("../../../../../Assets/PenPaths/filename (23).png"),
  },
];

export const PenPreview = (path: number) => {
  const pathPreview = paths.filter((i) => {
    return i.path === path;
  });

  if (pathPreview.length) {
    return (
      <div
        style={{
          height: "75px",
          width: "75px",
          margin: "0 auto",
          borderRadius: "10px",
          backgroundColor: "white",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url("${pathPreview[0].url}")`,
        }}
      />
    );
  }
  return null;
};
